import {Controller} from "@hotwired/stimulus"

// Drilldown row expand/collapse.
//
// The row's <span id="ROW_ID-icon"> renders three icons (plus / minus / spinner)
// via app/views/organizations/shared/_drilldown_icon.html.erb. State changes are
// pure `hidden` toggles -- no DOM mutation -- so the click handler stays safe
// with the Turbo Stream that fires from the same click.
export default class extends Controller {
  toggle(event) {
    const rowId = event.currentTarget.dataset['rowId']
    const wrapper = document.getElementById(`${rowId}-icon`)
    if (!wrapper) return

    const plus = wrapper.querySelector('.js-drilldown-plus')
    const minus = wrapper.querySelector('.js-drilldown-minus')
    const loader = wrapper.querySelector('.js-drilldown-loading')

    const expanded = minus && !minus.classList.contains('hidden')

    if (expanded) {
      // Collapse: purely client-side, suppress the Turbo navigation.
      event.preventDefault()
      minus.classList.add('hidden')
      if (plus) plus.classList.remove('hidden')
      this.removeWithChildren(rowId)
    } else {
      // Expand: show spinner, let Turbo fire. Server response swaps the
      // span contents to the expanded state of the same partial.
      if (plus) plus.classList.add('hidden')
      if (loader) loader.classList.remove('hidden')
    }
  }

  removeWithChildren(id) {
    document.querySelectorAll(`[data-child-of='${id}']`).forEach(el => {
      this.removeWithChildren(el.id)
      el.remove()
    })
  }
}
